import Title from '../base-text/variants/title';

type RadioBlockTitleProps = {
  title: string;
};

const RadioBlockTitle = ({ title }: RadioBlockTitleProps) => <Title.SM>{title}</Title.SM>;

export default RadioBlockTitle;
